import type { Story } from "@yomimono/types"

// Human-readable level label for a story, e.g.
// "Minna no Nihongo I (Second Edition) · Lesson 5". Returns null when the
// story carries no textbook/chapter (legacy stories, or generated with no
// textbook progress) so callers can omit the label entirely.
export function storyLevelLabel(
  story: Pick<Story, "textbookTitle" | "chapterNumber">
): string | null {
  if (!story.textbookTitle || story.chapterNumber == null) return null
  return `${story.textbookTitle} · Lesson ${story.chapterNumber}`
}
